'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindVenobox = undefined;

require('venobox');

var dom = {
  venoboxTrigger: '[venobox]'
};

var enableVenobox = function enableVenobox() {
  return $(dom.venoboxTrigger).venobox();
};

var bindVenobox = exports.bindVenobox = function bindVenobox() {
  var $triggers = $(dom.venoboxTrigger);
  if ($triggers.length) enableVenobox();
};